import { george, i18n, pr, React, theme, ui } from "aaa";
import { observer } from "mobx-react";
import externalInterfaceStore from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import trackingStore from "stores/TrackingStore";
import { HouseholdInsuranceRoutes } from "./HouseholdInsuranceRoutes";
import { HouseholdInsuranceStore } from "./HouseholdInsuranceStore";

/** Clears stacked primary + secondary fixed buttons (Success padding + gap + secondary block + page margin). */
const SUCCESS_VERTICAL_PADDING = 18;
const bottomStackPadding =
    SUCCESS_VERTICAL_PADDING +
    theme.ACTION_BUTTON_HEIGHT +
    SUCCESS_VERTICAL_PADDING +
    theme.MARGIN_SMALL +
    theme.ACTION_BUTTON_HEIGHT +
    theme.MARGIN +
    theme.MARGIN +
    theme.MARGIN;

const stackedFooter: React.CSSProperties = {
    position: "fixed",
    left: 0,
    right: 0,
    bottom: 0,
    width: "100%",
    maxWidth: theme.MAX_APP_WIDTH,
    marginLeft: "auto",
    marginRight: "auto",
    display: "flex",
    flexDirection: "column",
    paddingBottom: "max(0px, env(safe-area-inset-bottom))",
    boxSizing: "border-box",
};

const successInStack: React.CSSProperties = {
    position: "relative",
    bottom: "auto",
    left: "auto",
    right: "auto",
};

const secondaryInStack: React.CSSProperties = {
    position: "relative",
    bottom: 0,
    left: "auto",
    right: "auto",
    paddingTop: theme.MARGIN,
    paddingBottom: 0,
    width: "100%",
    maxWidth: theme.MAX_APP_WIDTH,
    backgroundColor: "transparent",
    fontSize: 16,
    color: "white",
    fontWeight: "bold",
};

interface IProps {
    store: HouseholdInsuranceStore;
}

export const HouseholdInsuranceSuccess = observer(({ store }: IProps) => {
    const [iconSize, setIconSize] = React.useState(0);

    const handoverUrl = store.handoverUrl;

    React.useEffect(() => {
        if (!handoverUrl) {
            pushRoute(HouseholdInsuranceRoutes.ROOT);
        }
    }, [handoverUrl]);

    React.useEffect(() => {
        window.scrollTo(0, 0);
        document.body.style.backgroundColor = theme.headerBackgroundColor(ui.isDarkMode);
        setIconSize(Math.min(ui.windowWidth * 0.4, theme.HEADER_ICON_SIZE));

        return () => {
            document.body.style.backgroundColor = "";
        };
    }, []);

    return (
        <george.MessageScreenBackground>
            <pr.VFlex style={{ height: "80%", paddingTop: 50 }}>
                <div>
                    <pr.IconMessageOk style={{ width: iconSize, height: iconSize, color: "white" }} />
                </div>
                <pr.MessageLabelContainer style={{ flex: 2 }}>
                    <pr.MessageScreenText>
                        <span role="text">
                            <i18n.FormattedHTMLMessage id="householdInsurance.success.message" />
                        </span>
                    </pr.MessageScreenText>
                </pr.MessageLabelContainer>
            </pr.VFlex>

            <george.PageWithActionButton
                style={{
                    paddingBottom: `calc(${bottomStackPadding}px + env(safe-area-inset-bottom, 0px))`,
                }}
            >
                <div style={stackedFooter}>
                    <a
                        href={externalInterfaceStore.isGeorgeApp
                            ? `georgeapp://at/open_external_link?url=${encodeURIComponent(handoverUrl)}`
                            : handoverUrl
                        }
                        target="_blank"
                        style={{ color: "white", textDecoration: "none", display: "block" }}
                    >
                        <george.SuccessButton
                            label={ui.__("householdInsurance.success.link")}
                            onClick={async () => {
                                await trackingStore.trackEvent({ eventName: "openPortal" });
                            }}
                            style={successInStack}
                        />
                    </a>
                    {externalInterfaceStore.isGeorgeApp && (
                        <george.SecondaryActionButton
                            messageId="common.backToGeorgeGo"
                            onClick={() => externalInterfaceStore.raiseExitSuccess()}
                            style={secondaryInStack}
                        />
                    )}
                </div>
            </george.PageWithActionButton>
        </george.MessageScreenBackground>
    );
});



// WEBPACK FOOTER //
// ./src/components/householdInsurance/HouseholdInsuranceSuccess.tsx